import React, { Component } from 'react'
import classnames from "classnames";

import Button from '../shared/Button';
import { Dropdown, Panel } from '../shared/Dropdown';
import selectStyles from './../../styles/select.styl';
import styles from './styles.styl';
import Input from '../shared/Input';


class DropdownForm extends Component {
  constructor(props) {
    super(props)

    this.onOpenChange = this.onOpenChange.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSearchValueChange = this.onSearchValueChange.bind(this);

    this.state = {
      isOpen: false,
      searchValue: '',
    }
  }

  onChange(field, value) {
    const { onChange } = this.props;

    this.setState({
      isOpen: false,
    });

    onChange(field, value);
  }

  onSearchValueChange(e) {
    const { value } = e.target;
    this.setState({ searchValue: !value ? '' : value.toLowerCase() });
  }

  get list() {
    const { list } = this.props;
    const searchValue = this.state.searchValue.toLowerCase();
    if (!searchValue) {
      return list;
    }
    return list.filter(el => (el || '').toLowerCase().indexOf(searchValue) > -1);
  }

  onOpenChange(value) {
    this.setState({ isOpen: value });
  }

  render() {
    const { isOpen, searchValue } = this.state;
    const { value, field, placeholder, className, positionBottom, hasSearchValue, addText } = this.props;
    const list = this.list;
    return (
      <div>
        <Button className={classnames(selectStyles.btn_select, className)} block dropdown onClick={() => this.onOpenChange(true)} >
          {value || placeholder}
        </Button>

        <Dropdown onOpenChange={this.onOpenChange} isOpen={isOpen} width="widthMd" positionBottom={positionBottom}>
          <Panel>
            {addText &&
              <p className={styles.add_text}>{addText}</p>
            }
            {hasSearchValue &&
              <div className={styles.search}>
                <Input type="text" placeholder="Find"
                  value={searchValue}
                  name="searchValue"
                  block
                  onChange={this.onSearchValueChange} />
                  <i className={styles.icon_search} />
              </div>
            }
            <ul className={selectStyles.container}>
              {list.map(item => (
                <li
                  className={classnames(selectStyles.item, {
                    [selectStyles.active]: value !== '' && item === value,
                  })}
                  key={`${field}_${item}`}
                >
                  <a onClick={() => this.onChange(field, item)}>
                    {`${item}`}
                  </a>
                </li>
              ))}
            </ul>
          </Panel>
        </Dropdown>
      </div >
    )
  }
}


export default DropdownForm;



// WEBPACK FOOTER //
// ./src/components/ApplicantForm/DropdownForm.jsx